export default __webpack_public_path__ + "static/media/polaroid24.4765ea83.jpg";